export function useDeviceType() {
  const ua = navigator.userAgent
  const isApple = /Mac|iPhone|iPad|iPod/.test(ua)
  const isWindows = /Win/.test(ua)
  const isAndroid = /Android/.test(ua)
  return { isApple, isWindows, isAndroid }
}
